import { render, staticRenderFns } from "./TableHeightFull.vue?vue&type=template&id=133e001b&scoped=true&"
import script from "./TableHeightFull.vue?vue&type=script&lang=js&"
export * from "./TableHeightFull.vue?vue&type=script&lang=js&"
import style0 from "./TableHeightFull.vue?vue&type=style&index=0&id=133e001b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e001b",
  null
  
)

export default component.exports